var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value === true)?_c('span',{staticClass:"green--text text--darken-2"},[_vm._v(" Yes ")]):_c('span',{staticClass:"red--text text--darken-2"},[_vm._v(" No ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }